<template>
</template>

<script>
    export default {
        name:"baseView",
        data(){
            return{
                //图片
                fileBaseUrl:"",//图片基础地址
                //分页
                currentPage: 1,
                pageSize: 10,
                total: 0,
                //
                orderType:"",//排序，0-正序，1-倒序
            }
        }
    }
</script>

<style lang="less" scoped>
@import '~utils/css/general.less';
@import '~utils/css/elementOften.less';
</style>